import { useEnvironmentVariables } from "#app/EnvironmentProvider.tsx";
import type { FileIconAssets, IconAssets, IllustrationAssets } from "#types/assets.ts";

export const useCdnAssets = () => {
    const { cdnBaseUrl } = useEnvironmentVariables();

    const getCdnAssetUrl = (assetPath: IconAssets | IllustrationAssets | FileIconAssets) => {
        return `${cdnBaseUrl}${assetPath}`;
    };

    return {
        getCdnAssetUrl
    };
};
